var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "booking-capacity-calender animate__animated animate__fadeIn",
      class: [
        _vm.activeTimePeriod,
        {
          "is-full-width": !_vm.isSidePanelOpen,
          loading: !!_vm.isLoading,
          six: _vm.numberOfDays === 6,
          seven: _vm.numberOfDays === 7,
          "is-flex is-flex-direction-column is-align-items-stretch":
            _vm.isMonthly,
        },
      ],
    },
    [
      !_vm.isMonthly
        ? _c(
            "div",
            { staticClass: "calendar-sidebar-times" },
            [
              _vm._m(0),
              _vm._l(_vm.weeklySideTimeBar, function (time, index) {
                return _c(
                  "div",
                  {
                    key: time.hour + "-" + time.minutes + "-" + index,
                    staticClass: "calendar-row",
                    class: { mounted: _vm.isComponentMounted },
                  },
                  [
                    _c("div", { staticClass: "calendar-time-cell" }, [
                      _c("div", [
                        time.showTime
                          ? _c("span", [
                              _vm._v(_vm._s(time.dateObj.toFormat("h:mma"))),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.isMonthly
        ? _c(
            "div",
            {
              staticClass: "calendar-row box-shadow no-border-bottom",
              class: { mounted: _vm.isComponentMounted },
              staticStyle: { "z-index": "1" },
            },
            _vm._l(_vm.weekDaysArr, function (day, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "calendar-cell unclickable",
                  class: { summary: day.className === "summary-cell" },
                  staticStyle: { height: "40px" },
                },
                [
                  _c("div", { staticClass: "cell-weekday" }, [
                    _c("span", [_vm._v(" " + _vm._s(day.name) + " ")]),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._l(_vm.calendarArr, function (week, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "calendar-row",
            class: {
              mounted: _vm.isComponentMounted,
              "is-flex-direction-row": _vm.isMonthly,
              "is-flex-direction-column": !_vm.isMonthly,
            },
            staticStyle: { "flex-grow": "1" },
          },
          [
            !_vm.isMonthly
              ? _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-flex-direction-column is-align-items-center is-justify-content-center calendar-day-cell",
                    class: {
                      "has-text-weight-bold": week.isToday,
                      "first-cell": index === 0,
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(week.dateObj.toFormat("ccc")))]),
                    _c("span", [_vm._v(_vm._s(week.dateObj.toFormat("d")))]),
                  ]
                )
              : _vm._e(),
            _vm._l(week.days, function (day, index1) {
              return _c(
                "div",
                {
                  key: index - index1,
                  ref: day.date,
                  refInFor: true,
                  staticClass: "calendar-cell",
                  class: {
                    "is-today": day.isToday,
                    "disabled-cell":
                      !day.isThisMonth ||
                      !day.isNonWorkingDay ||
                      (_vm.isQuoteDragging && !day.isCurrentOrFuture),
                    // selected cell is an array of selected cells, check if only one cell is selected and if it is the same as the current cell
                    "is-active":
                      _vm.selectedCell?.length == 1 &&
                      _vm.selectedCellDateStr == day.dateString &&
                      _vm.isSidePanelOpen,
                    // 'unclickable': !day.bookings.length,
                    monthMode: _vm.isMonthly,
                  },
                  attrs: {
                    draggable: !(_vm.isQuoteDragging && !day.isCurrentOrFuture),
                  },
                  on: {
                    dragover: function ($event) {
                      return _vm.dragOver($event)
                    },
                    dragleave: function ($event) {
                      return _vm.dragExit($event)
                    },
                    drop: function ($event) {
                      return _vm.drop($event, day, _vm.isMonthly)
                    },
                    click: function ($event) {
                      return _vm.handleCellClick([day])
                    },
                  },
                },
                [
                  _vm.isMonthly
                    ? _c("div", { staticClass: "cell-date" }, [
                        _c("div", [_vm._v(" " + _vm._s(day.date))]),
                      ])
                    : _vm._e(),
                  _vm.showBookingsAndCost && _vm.isMonthly
                    ? _c(
                        "div",
                        { staticClass: "cell-bookings has-text-weight-bold" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-flex-direction-column is-align-items-center",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "booking-cell-text-booked" },
                                [_vm._v(_vm._s(day.booked))]
                              ),
                              _c(
                                "span",
                                { staticClass: "jobs-label is-uppercase" },
                                [_vm._v("Jobs")]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-flex-direction-column is-align-items-center booking-cell-booked-cost",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm
                                        .calculateTotalSingleCellBookings(
                                          day.bookings
                                        )
                                        .toFixed(0),
                                      _vm.$userInfo.locale,
                                      false,
                                      0
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm.isMonthly
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-justify-content-center is-align-content-center",
                        },
                        [
                          day.bookings.length < 4
                            ? _c(
                                "div",
                                { staticStyle: { width: "100%" } },
                                _vm._l(
                                  day.bookings,
                                  function (booking, indexbooking) {
                                    return _c("div", { key: indexbooking }, [
                                      _c(
                                        "div",
                                        { staticClass: "quote-number-label" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "#" + _vm._s(booking.jobNumber)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-justify-content-center is-align-content-center",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "total-bookings-number" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(day.bookings.length) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ]
                      )
                    : day.bookings.length === 1
                    ? _c(
                        "div",
                        [
                          _c("calendar-weekly-bookings", {
                            attrs: {
                              booking: day.bookings[0],
                              "min-time": _vm.minTime,
                              "max-time": _vm.maxTime,
                              index: index1,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
            _vm.showBookingsAndCost && _vm.isMonthly
              ? _c(
                  "div",
                  {
                    staticClass: "calendar-cell monthMode summary",
                    class: {
                      "is-selected":
                        _vm.isSidePanelOpen &&
                        _vm.selectedCell?.length > 1 &&
                        _vm.selectedCellDateStr ===
                          week.days[0].dateString +
                            " - " +
                            week.days[week.days.length - 1].dateString,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleCellClick(week.days)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "cell-bookings" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-flex-direction-column is-align-items-center mt-5",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "booking-cell-text-booked-summary" },
                            [
                              _vm._v(
                                _vm._s(_vm.calculateTotals(week.days, "booked"))
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "total-jobs-text" }, [
                            _vm._v("Total Jobs"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-flex-direction-column is-align-items-center booking-cell-booked-cost",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "is-size-5 has-text-weight-semibold",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm
                                      .calculateTotalCosts(
                                        week.days,
                                        "totalIncGst"
                                      )
                                      .toFixed(0),
                                    _vm.$userInfo.locale,
                                    false,
                                    0
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "is-flex is-justify-content-center time-label" },
      [_c("span", [_vm._v("Time")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }